module.exports = __webpack_public_path__ + "static/media/close-icon-inverted.317dcfc0.svg";